<activar-sidebar
	[visible]="showSidebar()"
	(visibleChange)="exitSidebar()"
	[footer]="true">
	@if (loading()) {
		<app-quotes-detail-skeleton />
	} @else {
		<app-quotes-detail class="w-full"></app-quotes-detail>
	}

	@if (loading()) {
		<footer>
			<div
				class="h-12 bg-gray-200 rounded animate-pulse w-full mb-3"></div>
			<div class="h-12 bg-blue-200 rounded animate-pulse w-full"></div>
		</footer>
	} @else {
		<footer class="flex flex-col gap-4">
			<activar-button
				fill="out"
				class="justify-center w-full"
				expand="full"
				[loading]="quotesStore.state().loadingDownload"
				loadingText="Descargando..."
				(keydown)="downloadQuote()"
				(click)="downloadQuote()">
				<div class="text-primary-700 font-semibold text-base">
					Descargar
				</div>
			</activar-button>
			@if (showEmit()) {
				<activar-button
					[disabled]="!canEmit()"
					fill="solid"
					class="justify-center w-full"
					expand="full"
					(click)="redirectToQuoter()">
					<div class="font-semibold text-base w-full">Emitir</div>
				</activar-button>
			}

			@if (showInspect()) {
				<activar-button
					[disabled]="!canEmit()"
					fill="solid"
					class="justify-center w-full"
					expand="full"
					(click)="redirectToInspection()">
					<div class="font-semibold text-base w-full">Inspeccionar</div>
				</activar-button>
			}
			
		</footer>
	}
</activar-sidebar>
